var map = {
	"../career/career.module": [
		"./src/app/modules/career/career.module.ts",
		"common",
		"career-career-module"
	],
	"../materials/materials.module": [
		"./src/app/modules/materials/materials.module.ts",
		"common",
		"materials-materials-module"
	],
	"../members/members.module": [
		"./src/app/modules/members/members.module.ts",
		"common",
		"members-members-module"
	],
	"../news/news.module": [
		"./src/app/modules/news/news.module.ts",
		"common",
		"news-news-module"
	],
	"../orders/orders.module": [
		"./src/app/modules/orders/orders.module.ts",
		"orders-orders-module~products-products-module",
		"common"
	],
	"../pages/pages.module": [
		"./src/app/modules/pages/pages.module.ts",
		"common",
		"pages-pages-module"
	],
	"../products/products.module": [
		"./src/app/modules/products/products.module.ts",
		"orders-orders-module~products-products-module",
		"common",
		"products-products-module"
	],
	"../settings/settings.module": [
		"./src/app/modules/settings/settings.module.ts",
		"common",
		"settings-settings-module"
	],
	"../sliders/sliders.module": [
		"./src/app/modules/sliders/sliders.module.ts",
		"common",
		"sliders-sliders-module"
	],
	"../uac/uac.module": [
		"./src/app/modules/uac/uac.module.ts",
		"common",
		"uac-uac-module"
	],
	"./modules/dashboard/dashboard.module": [
		"./src/app/modules/dashboard/dashboard.module.ts",
		"common",
		"modules-dashboard-dashboard-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;